import EditorViewState from '../store/schema/EditorViewState';
import { TextDirection } from '../store/schema/TextDirection';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('Editor_setAdditionalProps', function setAdditionalProps(
    viewState: EditorViewState,
    textDirection: TextDirection,
    keyStrokeCount: number
) {
    viewState.textDirection = textDirection;
    viewState.keyStrokeCount = keyStrokeCount;
});
